<div class="container">
  <img src="../../../../assets/friends/Friend-Flourish-02_RED-sm.png">
  <p>You are now ALWAYS in edit mode, and the lesson plan now saves automatically.</p>
  <button class="submit" (click)="onDismiss()">Close</button>
</div>